import gql from 'graphql-tag';

export const lockerDeliveryFragment = gql`
  fragment lockerDeliveryParts on LockerDelivery {
    id
    depositDate
    unityGroupName
    unityName
    status
    withdrawalDate
    withdrawalCode
  }
`;

export const paginationFragment = gql`
  fragment paginationPartsForDelivery on Pagination {
    page
    totalPages
    pageSize
    totalResults
  }
`;

export const conciergeDeliveryFragment = gql`
  fragment conciergeDeliveryParts on ConciergeDelivery {
    id
    uuid
    receiverName
    withdrawerName
    addresseeName
    observations
    trackingCode
    status
    creationDate
    thumbnailUrl
    unityLabel
    endDate
  }
`;

export const porterDeliveryQrCodeFragment = gql`
  fragment porterDeliveryQrCodeParts on PorterDeliveryQrCode {
    uuid
    name
    shortLink
    settings {
      unitGroups
      description
      allowEntry
      placeIds
    }
    allowedContacts {
      intercom
      gsm
      videocall
    }
  }
`;

export const deliveryUnityWithResponsiblesFragment = gql`
  fragment deliveryUnityWithResponsiblesParts on DeliveryUnityWithResponsibles {
    unityId
    unityName
    unityGroupName
    floor
    responsibles {
      personContextId
      name
    }
  }
`;

export const deliveryUnityEligiblePersonFragment = gql`
  fragment deliveryUnityEligiblePersonParts on DeliveryUnityEligiblePerson {
    personContextId
    name
    profileId
    profileName
    hasDeliveryPermission
    isResponsible
    hasPushToken
  }
`;

export const deliveryNotifiedPersonFragment = gql`
  fragment deliveryNotifiedPersonParts on DeliveryNotifiedPerson {
    personContextId
    name
    hasPushToken
  }
`;
